module.exports = __webpack_public_path__ + "img/10.70672276.jpg";